"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushTypeEnvironment = exports.popTypeEnvironment = exports.replaceTypeEnvironment = exports.currentTypeEnvironment = exports.createBlockTypeEnvironment = void 0;
const lodash_1 = require("lodash");
function createBlockTypeEnvironment(context, name = 'blocktypeEnvironment', head = {}) {
    return {
        id: (0, lodash_1.uniqueId)(),
        name,
        tail: currentTypeEnvironment(context),
        head
    };
}
exports.createBlockTypeEnvironment = createBlockTypeEnvironment;
function currentTypeEnvironment(context) {
    return context.runtime.typeEnv[0];
}
exports.currentTypeEnvironment = currentTypeEnvironment;
function replaceTypeEnvironment(context, environment) {
    context.runtime.typeEnv[0] = environment;
}
exports.replaceTypeEnvironment = replaceTypeEnvironment;
function popTypeEnvironment(context) {
    return context.runtime.typeEnv.shift();
}
exports.popTypeEnvironment = popTypeEnvironment;
function pushTypeEnvironment(context, environment) {
    context.runtime.typeEnv.unshift(environment);
}
exports.pushTypeEnvironment = pushTypeEnvironment;
//# sourceMappingURL=typeEnvironment.js.map